var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownchevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2896_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78076 11.2734C8.38044 11.7736 7.61956 11.7736 7.21924 11.2734L3.30033 6.37656C2.77636 5.72182 3.2425 4.75172 4.08109 4.75172L11.9189 4.75172C12.7575 4.75172 13.2236 5.72182 12.6997 6.37655L8.78076 11.2734Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2896_1550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownchevron);
export default __webpack_public_path__ + "static/media/downchevron.5968e1c618f2d86c9aad90df7b8e35c8.svg";
export { ForwardRef as ReactComponent };